export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  isAdding: (state) => state.isAdding,
  isRefreshing: (state) => state.isRefreshing,
  list: (state) => state.list,
  paging: (state) => state.paging,
  statuses: (state) => state.statuses,
  summary: (state) => state.summary,
  nextPage: (state) => state.paging?.next_page,
};
